module.exports = __webpack_public_path__ + "img/role-process-web.ca815ab0.png";